import React, { useState, useEffect } from "react";
import Dynamsoft from 'dwt';
import { orgActions, alertActions } from "../../actions";
import { SERVER_URL } from "../../constants/constants.js";
import { connect } from "react-redux";


function ScanPage(props) {

  const { authentication, org, getDocTypes, alertSpinner, alertSuccess, alertCLear } = props;

  const jwt = authentication.jwt;
  const user_orgs = authentication.user.orgs;
  const org_id = Number(org.current_org_id);
  const upload_url = SERVER_URL + "/org/" + org_id + "/dealjacket?token=" + jwt;

  const [skipAirtable, setSkipAirtable] = useState(false);
  const [selectedDocType, setSelectedDocType] = useState('Select a Document Type');
  const [docName, setDocName] = useState('');


  const current_org = user_orgs.filter(
    (org) => org.org_id === org_id
  )[0];

  const current_org_name = current_org.display_name;
  const use_doctypes = current_org.allow_doc_types;
  const single_org_user = user_orgs?.length === 1;
  const user_doctypes = authentication?.user?.doctypes?.filter((doctype) => doctype.org_id === org.current_org_id);
  const org_doctypes = org?.doc_types;

  const doctypes = (user_doctypes?.length > 0) ? user_doctypes?.map((doctype) => doctype.doc_type_name) : org_doctypes?.map((doctype) => doctype.doc_type);


  const [DWObject, setDWObject] = useState({});
  const [containerId, setContainerId] = useState("dwtcontrolContainer");
  const [imagesInDocument, setImagesInDocument] = useState(0);
  const [validationError, setValidationError] = useState(false);


  const spinner = require("../../images/spinner-purple.svg").default;

  const webTwainId = "dwtcontrol";

  useEffect(() => {
    getDocTypes(current_org?.org_id);
  }, [current_org])

  useEffect(() => {
    if (!Dynamsoft.DWT.organizationID) {
      Dynamsoft.DWT.organizationID = "100657642";
    }
    Dynamsoft.DWT.ResourcesPath = "/dwt-resources";

    Dynamsoft.DWT.CustomizableDisplayInfo.loaderBarSource = spinner;

    Dynamsoft.DWT.CreateDWTObjectEx({
      WebTwainId: webTwainId
    },
      function (obj) {
        obj.LogLevel = 1;
        console.log(obj);
        setDWObject(obj);
      },
      function (err) {
        console.log(err);
      }
    );

    return () => {
      Dynamsoft.DWT.DeleteDWTObject(webTwainId);
    }
  }, [containerId, org_id]);


  const clearImagesInDocument = () => {
    DWObject.RemoveAllImages();
    setImagesInDocument(0);
  };

  const onChangeDocType = (e) => {
    setSelectedDocType(e.target.value);
  }

  const onChangeDocName = (e) => {
    setDocName(e.target.value);
  }

  const onClickUpload = (e) => {
    let err = false;
    if (docName.length > 3) {
      err = false;
    }
    if (use_doctypes && selectedDocType === "Select a Document Type") {
      err = true;
    }
    if (err) {
      setValidationError(true);
      console.log(true);
    }
    if (DWObject.HowManyImagesInBuffer < 1) {
      setValidationError(true);
      console.log(true);
    }
    if (!err) {
      setValidationError(false);
      console.log(false);
      uploadDoc();
    }
  }

  const acquireImage = () => {
    if (DWObject) {

      DWObject.RegisterEvent("OnPostTransfer", function () {
        setImagesInDocument(DWObject.HowManyImagesInBuffer);
      });

      DWObject.Viewer.unbind();
      DWObject.Viewer.bind(document.getElementById(containerId));
      DWObject.Viewer.height = 400;
      DWObject.Viewer.width = 400;

      var thumbnailViewer = DWObject.Viewer.createThumbnailViewer();
      thumbnailViewer.show();
      DWObject.Viewer.show();

      DWObject.SelectSource(function () {

        DWObject.OpenSource();
        console.log(DWObject.ErrorString);

        DWObject.AcquireImage(
          () => {
            console.log(DWObject.ErrorString);
          },
          () => {
            console.log(DWObject.ErrorString);
          }
        );

      }, function () {
        console.log('SelectSource failed!');
      });
    }
  }



  function uploadDoc() {
    const indices = DWObject.SelectAllImages();
    DWObject.ConvertToBlob(
      indices,
      4,
      function (result, _indices) {
        var url = upload_url + "&doctype=" + selectedDocType;
        if (docName.indexOf('.pdf')) {
          var fileName = docName;
        } else {
          var fileName = docName + ".pdf";
        }
        var formData = new FormData();
        formData.append('file', result, fileName);
        makeRequest(url, formData);
      },
      function (errorCode, errorString) {
        console.log(errorCode + ":" + errorString);
      }
    );
  }

  function makeRequest(url, formData) {
    // Set up the request
    alertSpinner();
    let xhr;
    if (window.XMLHttpRequest) {
      xhr = new XMLHttpRequest();
    } else {
      if (window.ActiveXObject) {
        try {
          xhr = new ActiveXObject("MSXML2.XMLHTTP.3.0");
        } catch (ex) {
          alert(ex);
        }
      }
    }
    if (xhr) {
      // Send the Data via POST
      xhr.open("POST", url, false);
      if (formData != null) {
        xhr.send(formData);
        alertSuccess("Your document has been uploaded. It will appear in search within a few minutes.")
      } else {
        xhr.send(null);
      }

    } else {
      alert("Sorry, I couldn't create the upload request. Please contact help@gotagtech.com");
    }
  }


  const doctypes_html = doctypes?.map((doctype, i) => (
    <>
      <option key={doctype + "-" + i} id="doctype" name="doctypes" value={doctype}>
        {doctype}
      </option>
    </>
  ));


  return (
    <>
      {validationError &&
        <div className="scanPageValidationMessage">Please fill out all required fields and try again.</div>
      }

      <div className="scanPageContainer">

        <div className="scanViewerContainer">
          <span className="scanViewerHeader">Document Preview</span><br />
          <span className="scanViewerPromptMessage">
            Load pages into your scanner, then click the "Add Pages to Document" button on the right to begin scanning.
          </span>
          <div className="dwControlContainer" id={containerId}>
          </div>
        </div>
        <div className="scanActionsContainer">
          <table className="ingestorFormTable">
            <tbody>
              <tr>
                <td>{imagesInDocument} pages in document.</td>
                <td><button onClick={() => acquireImage()} ><a>Add Pages to Document</a></button> </td>
              </tr>
              <tr>
                <td colSpan="2"><br /><hr /><br /></td>
              </tr>
              <tr>
                <td>Give this Document a Name:</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td colSpan="2"><input className="uploadConfirm" type="text" size="52" onChange={onChangeDocName} placeholder="enter document name here..."></input><br /><br /></td>
              </tr>
              {(use_doctypes) &&
                <>
                  <tr>
                    <td>Select Document Type:</td>
                    <td>
                      <select className="orgDropdown"
                        value={selectedDocType ? selectedDocType : "select a doc type"}
                        onChange={(e) => onChangeDocType(e)}
                      >
                        <option key="select" id="doctype" name="doctypes" value="Select a Document Type">
                          Select a Document Type
                        </option>
                        {doctypes_html}
                      </select>
                    </td>
                  </tr>

                </>
              }
              <tr>
                <td colSpan="2"><br /><hr /><br /></td>
              </tr>
              <tr>
                <td></td>
                <td><button className="uploadButton" onClick={onClickUpload}>Upload Document to {current_org_name}</button> </td>
              </tr>
              <tr>
                <td></td>
                <td><button className="cancelButton" onClick={clearImagesInDocument}>Abandon Upload</button></td>
              </tr>
            </tbody>
          </table>


        </div>
      </div>
    </>
  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  getDocTypes: orgActions.getDocTypes,
  alertSpinner: alertActions.spinner,
  alertSuccess: alertActions.success,
};

const connectedScanPage = connect(
  mapStateToProps,
  actionCreators
)(ScanPage);
export { connectedScanPage as ScanPage };